import { VisitPrerequisiteStepId } from "render/hooks/api/useVisitPrerequisites";
import { Action, Event } from "render/hooks/useTracking";

const category = "AppointmentView";

export const appointmentEvents = {
  completeProfileClick: (): Event => {
    return {
      category,
      action: Action.Click,
      label: "complete_profile",
    };
  },

  completeProfileStepClick: (step: VisitPrerequisiteStepId): Event => {
    return {
      category,
      action: Action.Click,
      label: "complete_profile_click",
      value: step,
    };
  },
};
